export class NewOutBoxMessage {
    sendBy: string;
    templateId: number;
    userIds: number[];
    action: string;
}
